"use strict";var r;exports.GridType=void 0,(r=exports.GridType||(exports.GridType={})).CAROUSEL="carousel",r.GRID="grid";
//# sourceMappingURL=types.js.map
